"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProductListingData = void 0;
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _productListingPage = require("../queries-net/productListingPage");
/* istanbul ignore file @preserve */ /**
 * Fetch function that fetches data for Product Listing page from GraphQL.
 * limit & skip are in rows, 1 row = 4 positions (products or banners)
 */ const getProductListingData = async (param)=>{
    let { atpClusterId, pageId, channelType, token, graphQlUrl, sourceAppName, customerTypeId, tenant, staticApiUrl, language, limit, previewMode, hasFilters } = param;
    const staticApiClient = new _staticApiClientReact.ApiClient({
        baseUrl: staticApiUrl,
        language,
        tenant
    });
    const headers = (0, _presentationHttp.getHeaders)({
        sourceAppName,
        language,
        tenant,
        token,
        atpClusterId,
        customerTypeId
    });
    const [data, { data: productBoxConfiguration }] = await Promise.all([
        (0, _fetching.fetchGraphql)({
            query: _productListingPage.productListingQuery,
            url: graphQlUrl,
            variables: {
                pageId,
                breadcrumbsPageUrl: pageId,
                categoryBarId: pageId,
                channelType,
                limit,
                hasFilters
            },
            headers: {
                ...headers,
                [_fetching.CHANNEL_TYPE]: channelType,
                [_fetching.PREVIEW_MODE]: previewMode !== null && previewMode !== void 0 ? previewMode : false
            },
            ...previewMode ? {
                timeout: 30000
            } : null
        }),
        (0, _staticApiClientReact.getTenantApplicationsProductboxConfiguration)(staticApiClient, tenant, {
            customerTypeId: customerTypeId !== null && customerTypeId !== void 0 ? customerTypeId : undefined
        })
    ]);
    return {
        data,
        productBoxConfiguration
    };
};
exports.getProductListingData = getProductListingData;
